import React from 'react';
import { Badge, BadgeProps } from '@chakra-ui/react';

interface OrderBadgeProps extends Omit<BadgeProps, 'children'> {
  value: number | null | undefined;
  emptyText?: string;
  emptyColorPalette?: string;
  valueColorPalette?: string;
}

const OrderBadge: React.FC<OrderBadgeProps> = ({ 
  value,
  emptyText = 'Not Set',
  emptyColorPalette = 'gray',
  valueColorPalette = 'brand',
  variant = 'outline',
  size = 'sm',
  ...badgeProps 
}) => {
  const hasValue = value !== null && value !== undefined;
  
  return (
    <Badge 
      size={size}
      variant={variant}
      colorPalette={hasValue ? valueColorPalette : emptyColorPalette}
      {...badgeProps}
    >
      {hasValue ? `${value}` : emptyText}
    </Badge>
  );
};

export default OrderBadge; 